module.exports = __webpack_public_path__ + "static/img/coupon-blur.bd91b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/coupon-blur.png
// module id = Kh4S
// module chunks = 4